'use client';

import { YStack, Anchor } from '@cxnpl/ui';
import { ChevronLeft } from '@cxnpl/ui/icons';
import { useTranslation } from 'react-i18next';

export interface StoryFormDisplayProps {
  children: React.ReactNode | undefined;
  onPressBack: () => void;
}

export function PageBackNavigationFrame({ children, onPressBack }: StoryFormDisplayProps) {
  const { t } = useTranslation();

  return (
    <YStack
      width="100%"
      backgroundColor="$background/surface"
      padding={0}
      borderRadius="$surface/radius/surface-radius"
      $tablet={{
        maxWidth: 536,
      }}
      $laptop={{
        maxWidth: 468,
      }}
    >
      <YStack
        height="$7xl"
        justifyContent="center"
        alignItems="flex-start"
        //TODO: There is way more space in the designs, but no semantic token. Fix once a Text only button is made
        paddingHorizontal="$lg"
      >
        <Anchor
          variant="bodyMediumEm"
          cursor="pointer"
          onPress={() => {
            onPressBack();
          }}
          display="flex"
          alignItems="center"
          gap="$xs"
        >
          <ChevronLeft color="$button/color/button-primary-text" size="$xs" />
          {t('help.components.pageBackNavigationFrame.linkBackLabel')}
        </Anchor>
      </YStack>
      <YStack
        $tablet={{ paddingBottom: '$7xl', paddingLeft: '$7xl', paddingRight: '$7xl' }}
        $laptop={{ paddingBottom: '$5xl', paddingLeft: '$5xl', paddingRight: '$5xl' }}
        $mobile={{ paddingBottom: '$2xl', paddingLeft: '$2xl', paddingRight: '$2xl' }}
      >
        {children}
      </YStack>
    </YStack>
  );
}
